import React from 'react';
import CategoryWithSelects from './MainPageCategoryWithSelects';
import CategoryWithLinks from './MainPageCategoryWithLinks';


export default function MainPageCategory(props) {
  if (props.withSelects) {
    return <CategoryWithSelects {...props} />
  }
  return <CategoryWithLinks {...props} />;
}



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MainPageCategory.jsx
 **/